import React from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/constants/brand";

const initials = (name) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32 bg-[#FAFAFA] border-y border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <p className="uppercase text-xs tracking-[0.22em] font-bold text-[#0055FF]">
              Voices from the field
            </p>
            <h2 className="font-display mt-4 text-4xl md:text-5xl tracking-tight font-bold text-[#0B1120] leading-tight">
              Indian operators. Indian outcomes.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-8">
            <p className="text-base md:text-lg text-[#475569] leading-relaxed">
              A snapshot of how SME leaders describe their work with Infolocus —
              across manufacturing, retail, logistics and healthcare.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="relative bg-white border border-[#E2E8F0] rounded-sm p-8 md:p-10 shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5"
            >
              <Quote className="absolute top-6 right-6 h-7 w-7 text-[#E2E8F0]" />
              <p className="font-display text-lg md:text-xl text-[#0B1120] leading-relaxed">
                “{t.quote}”
              </p>
              <div className="mt-8 flex items-center gap-4 pt-6 border-t border-[#E2E8F0]">
                <div className="h-12 w-12 flex items-center justify-center rounded-sm bg-[#1B2A6E] text-white font-display font-bold text-sm">
                  {initials(t.name)}
                </div>
                <div>
                  <div className="text-sm font-bold text-[#0B1120]">{t.name}</div>
                  <div className="text-xs text-[#475569]">
                    {t.title}, {t.company}
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.18em] font-semibold text-[#0055FF] mt-0.5">
                    {t.industry}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
